import { useEffect, useState } from "react"
import { DetailPage } from "../../components/crud/DetailPage"
import { ListPage } from "../../components/crud/ListPage"
import { Form } from "../../components/forms/Form"
import { AsyncSelect, TextInput } from "../../components/forms/Inputs"
import { Popup } from "../../components/layout/Popup"
import { useTranslations } from "../../layers/Localization"
import { OffreModeleDetailsList } from "./OffreModeleDetail"
import { useOptions } from "../../hooks/useOptions"
import { useApi } from "../../hooks/useApi"
import { Button } from "../../components/layout/Button"
import { FaBan, FaPaintBrush } from "react-icons/fa"

const useActions = ({ setOffreModeleId, setReload }) => {
    const t = useTranslations()
    return {
        [t('Copier offre')]: (item, reload) => {
            setOffreModeleId(item.id)
            setReload(() => reload)
        }
    }
}

function OffreModeleFields({ item, set, tab }) {
    const t = useTranslations()
    return <>
        <TextInput label={t("Nom")} value={item.nom} onChange={set('nom')} required />
    </>
}

export function OffreModelesList(props) {
    const [offreModeleId, setOffreModeleId] = useState()
    const [reload, setReload] = useState()

    const t = useTranslations()
    const actions = useActions({ setOffreModeleId, setReload })

    return <>
        <ListPage model="offreModele" title={t("Modèles d'offres")} columns={{
            [t('Nom')]: 'nom',
        }} actions={actions} {...props} />
        <CopyOffrePopup offreModeleId={offreModeleId} setOffreModeleId={setOffreModeleId} reload={reload} />
    </>
}

export function OffreModeleDetail(props) {
    const [offreModeleId, setOffreModeleId] = useState()
    const [reload, setReload] = useState()

    const t = useTranslations()
    const actions = useActions({ setOffreModeleId, setReload })

    return <>
        <DetailPage model="offreModele" title={t("Modèle d'offres")} Fields={OffreModeleFields} actions={actions} tables={{
            [t("Détails")]: <OffreModeleDetailsList relation="offreModeleId" root="." />
        }} {...props} />
        <CopyOffrePopup offreModeleId={offreModeleId} setOffreModeleId={setOffreModeleId} reload={reload} />
    </>
}

function CopyOffrePopup({ offreModeleId, setOffreModeleId, reload }) {
    const [offreId, setOffreId] = useState()

    const api = useApi()
    const t = useTranslations()
    const offreOptions = useOptions('offres', ["num", "reference"])

    useEffect(() => {
        setOffreId(null)
    }, [offreModeleId])

    const reset = () => setOffreModeleId(null)
    const apply = async () => {
        api.post(`/offreModele/${encodeURIComponent(offreModeleId)}/copy-offre`, { offreId })
        setOffreModeleId(null)
        reload()
    }

    return <Popup value={!!offreModeleId} onChange={setOffreModeleId}>
        <Form onSubmit={apply}>
            <h2 className="text-xl mb-3">{t("Quelle offre désirez-vous copier ?")}</h2>
            <div className="mb-8">{t("Attention ! Toutes les données existantes seront écrasées !")}</div>
            <AsyncSelect value={offreId} onChange={setOffreId} options={offreOptions} required className="mb-8" />
            <div className="flex gap-3">
                <Button gray icon={<FaBan />} onClick={reset}>{t("Annuler")}</Button>
                <Button icon={<FaPaintBrush />} submit>{t("Appliquer")}</Button>
            </div>
        </Form>
    </Popup>
}